import { forwardRef } from "react";

// iter 372r — Florida state outline for the sidebar "Florida" item.
// iter 372s — path regenerated from the CC0 Wikimedia "Blank US Map"
// state geometry (parsed, simplified via shapely, scaled to 24×24) so
// it's the real Florida shape rather than a hand-drawn approximation.
export const FloridaIcon = forwardRef(function FloridaIcon(
  { size = 24, className = "", strokeWidth = 1.4, ...rest },
  ref,
) {
  const { fill, stroke, ...passthrough } = rest;
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...passthrough}
    >
      <path d="M16.2 4.6L15.2 4.6L15.1 5.8L14.9 5.2L8.6 5.6L8.2 4.9L2.0 5.9L2.5 7.5L5.2 7.0L7.8 8.5L10.3 7.2L11.8 7.6L14.6 10.0L14.4 12.7L14.9 13.5L15.5 12.7L14.9 13.8L16.6 16.4L16.6 15.0L18.1 17.9L19.0 17.8L19.6 19.4L20.8 19.4L22.0 17.5L21.7 14.5Z" />
    </svg>
  );
});
